import { DotLegalDeleteDialog } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { Trans } from "react-i18next";
import { useTranslation } from "../../localization/useTranslation.ts";
import { AccessControlEntity, useAccessResponsibilityHelper } from "./useAccessResponsibilityHelper.hooks.ts";
import ResponsibleField from "./ResponsibleField.tsx";

export interface AccessAwareResponsibleFieldProps<T extends AccessControlEntity> {
    entity: T | undefined;
    isLoading: boolean;
    onChange: (changeFunc: (entity: T) => void) => Promise<void>;
    onConfirmNavigate: () => void;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
    toolTipText?: string;
    warningText?: string;
    disableAccessWarning?: boolean;
}

function AccessAwareResponsibleField<T extends AccessControlEntity>(props: AccessAwareResponsibleFieldProps<T>) {
    const { translateString } = useTranslation();
    const { onFieldChange, handleDialogConfirm, pendingUserChanges, setPendingUserChanges } = useAccessResponsibilityHelper<T>(
        props.onChange,
        props.onConfirmNavigate,
        props.disableAccessWarning
    );

    return (
        <>
            <ResponsibleField
                responsibleId={props.entity?.responsibleId}
                isLoading={props.isLoading}
                onChange={(responsibleId) => {
                    let newEntity = { ...props.entity!, responsibleId };
                    onFieldChange(newEntity, props.entity!);
                }}
                readOnly={props.readOnly}
                disabled={props.disabled}
                isPreview={props.isPreview}
                errorText={props.errorText}
                toolTipText={props.toolTipText}
                warningText={props.warningText}
            />

            {pendingUserChanges && (
                <DotLegalDeleteDialog
                    open
                    headerText={translateString("confirmAccessRemoval")}
                    alertBodyText={
                        <Trans
                            i18nKey="confirmSystemAccessRemovalBody"
                            components={{
                                ul: <ul />,
                                li: <li />,
                            }}
                        />
                    }
                    warningTranslation={translateString("warning")}
                    deleteBtnText={translateString("save")}
                    cancelBtnText={translateString("cancel")}
                    onDialogClose={() => setPendingUserChanges(null)}
                    onOkClick={() => handleDialogConfirm()}
                />
            )}
        </>
    );
}

export default AccessAwareResponsibleField;
